import styles from './index.module.css';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJs,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from 'chart.js'

const ScatterChart = ({ chartData, chartOptions, label }) => {

  ChartJs.register(CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  return (
    <div className={styles.card}>
      <div className={styles.cardTopic}>
        <p className={styles.title}>{label}</p>
      </div>
      <div className={styles.barChart}>
        <Line
          data={chartData}
          options={chartOptions}
        />
      </div>
    </div>
  );
};

export default ScatterChart;